import useApiConfig from '../../../core/apiHooks/useApiConfig';
import { useGetMultipleOffersQuery } from '../../../core/apis/hondaRestApi';
import { usePageState } from '../../../utils/sitecoreContext';
const specialOfferType = {
    stackableRebate: 'StackableRebate',
    nonStackableRebate: 'NonStackableRebate',
};
const useFetchAllOffers = (trims, canUseLoyalty = false) => {
    const allTransmissionIds = trims
        .map(offer => offer.transmissionKey)
        .filter(Boolean)
        .join(';');
    const apiConfig = useApiConfig();
    const pageState = usePageState();
    const { data = [], isFetching, isLoading, isSuccess, error, isUninitialized, } = useGetMultipleOffersQuery({
        ...apiConfig,
        pageState,
        withLoyalty: canUseLoyalty,
        transmissionIds: allTransmissionIds,
    }, { skip: !allTransmissionIds.length || !pageState });
    return {
        data,
        isFetching,
        isLoading,
        isSuccess,
        error,
        isUninitialized,
    };
};
export default useFetchAllOffers;
